import ApiService from "@/core/services/api.service";
import { STATUS_CODE } from "@/core/config/constant";
import { SET_ERROR } from "@/core/services/store/auth.module";
// mutation types
export const GET_LIST_ANSWER = "getListAnswer";
export const SET_LIST_ANSWER = "setListAnswer";
export const LIST_ANSWER = "listAnswer";
export const CHECK_FORM_URL_USER = "checkFormUrlUser";
export const LIST_CHECK_FORM_URL_USER = "listCheckFormUser";
export const SET_LIST_CHECK_FORM_URL_USER = "setListCheckFormUser";
export const GET_DETAIL_ANSWER = "getDetailAnswer";
export const SET_DETAIL_ANSWER = "setDetailAnswer";
export const DETAIL_ANSWER = "detailAnswer";
const { SUCCESS, BAD_REQUEST } = STATUS_CODE;
export const SET_STATUS = "SetStatus"
export const SET_ERROR_MESSAGE = "SetErrorMessage"
export const GET_ALL_URL_ADMIN = "GetAllUrlAdmin"
export const SET_ALL_URL_ADMIN = "SetAllUrlAdmin"


const state = {
    listAnswer: [],
    listCheckFormUser: {},
    detailAnswer: {},
    errors: null,
    status: null,
    form_url: null
};

const getters = {
    getListAnswer: state => state.listAnswer,
    listCheckFormUsers: state => state.listCheckFormUser,
    detailAnswer: state => state.detailAnswer,
    getListAnswerStatus: state => state.status,
    getListAnswerErrors: state => state.errors,
    form1Url: state => state.form_url.form_1,
    form2Url: state => state.form_url.form_2,
    form3Url: state => state.form_url.form_3,
    form4Url: state => state.form_url.form_4,
    form5Url: state => state.form_url.form_5,
    form6Url: state => state.form_url.form_6,
};


const mutations = {
    [SET_LIST_ANSWER](state, listAnswer) {
        state.listAnswer = listAnswer;
    },
    [SET_LIST_CHECK_FORM_URL_USER](state, listCheckFormUser) {
        state.listCheckFormUser = listCheckFormUser;
    },
    [SET_DETAIL_ANSWER](state, detailAnswer) {
        state.detailAnswer = detailAnswer;
    },
    [SET_STATUS](state, code) {
        state.status = code;
    },
    [SET_ERROR_MESSAGE](state, errors) {
        state.errors = errors
    },
    [SET_ALL_URL_ADMIN](state, form) {
        state.form_url = form
    }
};


const actions = {
    async [LIST_ANSWER](context, data) {
        context.commit(SET_STATUS, null)
        context.commit(SET_ERROR_MESSAGE, null)

        const searchParams = new URLSearchParams();
        let params = data?data: {};
        Object.keys(params).forEach(key => searchParams.append(key, params[key]));
        try {
            const response = await ApiService.get("form/list-answer?"+searchParams.toString())
            if (response.data.code == SUCCESS) {
                context.commit(SET_LIST_ANSWER, response.data.data);
                context.commit(SET_STATUS, response.data.code)
            }
            if (response.data.code == BAD_REQUEST) {
                context.commit(SET_STATUS, response.data.code)
                context.commit(SET_ERROR_MESSAGE, response.data.data)
            }
        } catch (e) {
            if (e.response.data.code == ERROR_SERVER) {
                context.commit(SET_ERROR, e.response.data.message);
                throw e.response.data.message
            } else {
                throw e;
            }
        }

    },
    async [CHECK_FORM_URL_USER](context) {
        context.commit(SET_STATUS, null)
        context.commit(SET_ERROR_MESSAGE, null)
        try {
            const response = await ApiService.get('form/check-form-user')
            if (response.data.code == SUCCESS) {
                context.commit(SET_LIST_CHECK_FORM_URL_USER, response.data.data);
                context.commit(SET_STATUS, response.data.code)
            }
            if (response.data.code == BAD_REQUEST) {
                context.commit(SET_STATUS, response.data.code)
                context.commit(SET_ERROR_MESSAGE, response.data.data)
            }
        } catch (e) {
            if (e.response.data.code == ERROR_SERVER) {
                context.commit(SET_ERROR, e.response.data.message);
                throw e.response.data.message
            } else {
                throw e;
            }
        }

    },
    async [GET_DETAIL_ANSWER](context, { id }) {
        context.commit(SET_STATUS, null)
        context.commit(SET_ERROR_MESSAGE, null)
        context.commit(SET_DETAIL_ANSWER, {});
        try {
            const response = await ApiService.get(`form/answer-detail/${id}`)
            if (response.data.code == SUCCESS) {
                context.commit(SET_DETAIL_ANSWER, response.data.data);
                context.commit(SET_STATUS, response.data.code)
            }
            if (response.data.code == BAD_REQUEST) {
                context.commit(SET_STATUS, response.data.code)
                context.commit(SET_ERROR_MESSAGE, response.data.data)
            }
        } catch (e) {
            if (e.response.data.code == ERROR_SERVER) {
                context.commit(SET_ERROR, e.response.data.message);
                throw e.response.data.message
            } else {
                throw e;
            }
        }

    },
    async [GET_ALL_URL_ADMIN](context) {
        context.commit(SET_STATUS, null)
        context.commit(SET_ERROR_MESSAGE, null)
        context.commit(SET_ALL_URL_ADMIN, {});

        try {
            const response = await ApiService.get(`form/get-all-url-admin`)
            if (response.data.code == SUCCESS) {
                context.commit(SET_ALL_URL_ADMIN, response.data.data);
                context.commit(SET_STATUS, response.data.code)
            }
            if (response.data.code == BAD_REQUEST) {
                context.commit(SET_STATUS, response.data.code)
                context.commit(SET_ERROR_MESSAGE, response.data.data)
            }
        } catch (e) {
            if (e.response.data.code == ERROR_SERVER) {
                context.commit(SET_ERROR, e.response.data.message);
                throw e.response.data.message
            } else {
                throw e;
            }
        }
    }
}



export default {
    state,
    actions,
    mutations,
    getters
};
